<template>
    <div @click="remove">X</div>
</template>
<script>
    import axios from 'axios';
    import eventHub from '../../../library/event-hub';

    export default {
        props: {
            cartItem: {
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                item: {}
            };
        },
        mounted() {
            this.item = this.cartItem;
        },
        methods: {
            remove() {
                console.log({ storage: this.item.storage_id })
                let api_url = `${base_url}/api/carts/delete/${this.item.product_id}`;
                axios.delete(api_url, { data: { storage: this.item.storage_id } })
                    .then(success_response => {
                        eventHub.$emit('cart-updated', success_response.data);
                    })
                    .catch(error => {
                        let error_response;
                        if (error.isAxiosError) {
                            error_response = error.response;
                        } else {
                            console.log('error', error);
                        }
                    });
            }
        }
    }
</script>
<style lang="">

</style>